import React from 'react';
import DesktopRedirectPage from '@pages/signin/DesktopRedirectPage';

function DesktopSignInRedirectPage() {
    return <DesktopRedirectPage />;
}

export default DesktopSignInRedirectPage;
